module.exports = __webpack_public_path__ + "img/jinyingjiang.35d91541.png";